import React, { useContext, useEffect, useRef, useState } from "react";
import FormCreator from "../../../../../../components/finalForms/FormCreator";
import { pendingSpecificationsConfig } from "./Specifications.formfield.config";
import { useGetAllSalesrepsMutation, useGetContractAgreementTemplateMutation, useLazyGetAllContractTypeQuery } from "../../../../../../app/services/contractAPI";
import { setDropdownOptions } from "../../../../../../components/finalForms/libs/data/mapDropdownOptions";
import { setFieldSetting } from "../../../../../../utils/formFieldUtils/ManageFields";
import { FieldSettingType } from "../../../../../../components/finalForms/libs/data/fieldSettingType";
import { PendingContractContext } from "../../../../../../utils/context/PendingContractContext";
import { getDropdownValue } from "../../../../../../utils/formFieldUtils/getDropdownValue";
import { ServiceLocationContext } from "../../../../../../utils/context/ServiceLocationContext";

const Specifications = () => {
  const SpecificationsRef = useRef();
  const [pendingSpecificationsForm, setPendingSpecificationsForm] = useState(pendingSpecificationsConfig);

  const { pendingContractData, pendingContractId } = useContext(PendingContractContext) || {};

  const { selectedLocation } = useContext(ServiceLocationContext);
  const locationkey = getDropdownValue(selectedLocation);

  const [getAllContractType, {
    isSuccess: isAllContractTypeFetched,
    data: AllContractTypeData
  }] = useLazyGetAllContractTypeQuery();

  const [getAllSalesreps, {
    isSuccess: isAllSalesrepsFetched,
    data: AllSalesrepsData
  }] = useGetAllSalesrepsMutation();

  const [getAllContractAgreementTemplate, {
    isFetching: isAllContractAgreementTemplateFetching,
    isSuccess: isAllContractAgreementTemplateFetched,
    data: AllContractAgreementTemplateData,
  }] = useGetContractAgreementTemplateMutation();

  useEffect(() => {
    if (locationkey) {
      getAllContractAgreementTemplate(locationkey);
      setFieldSetting(pendingSpecificationsForm, 'lPendingContractAgreementTemplateKey', FieldSettingType.ISFIELDDATALOADING, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationkey])

  useEffect(() => {
    if (!isAllContractAgreementTemplateFetching && isAllContractAgreementTemplateFetched && AllContractAgreementTemplateData) {
      setDropdownOptions(AllContractAgreementTemplateData, 'lPendingContractAgreementTemplateKey', 'sPendingContractAgreementTemplate', pendingSpecificationsForm, 'lPendingContractAgreementTemplateKey', setPendingSpecificationsForm);
      setFieldSetting(pendingSpecificationsForm, 'lPendingContractAgreementTemplateKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllContractAgreementTemplateFetching, isAllContractAgreementTemplateFetched, AllContractAgreementTemplateData])

  useEffect(() => {
    getAllContractType(true);
    const SalesrepReq = { pbIncludeBlank: true, psActiveFlag: 'Y' }
    getAllSalesreps(SalesrepReq);
    setFieldSetting(pendingSpecificationsForm, 'lContractTypeKey', FieldSettingType.ISFIELDDATALOADING, true);
    setFieldSetting(pendingSpecificationsForm, 'lSalesRepKey', FieldSettingType.ISFIELDDATALOADING, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingContractId])

  useEffect(() => {
    if (isAllContractTypeFetched && AllContractTypeData) {
      setDropdownOptions(AllContractTypeData, 'lContractTypeKey', 'sContractType', pendingSpecificationsForm, 'lContractTypeKey', setPendingSpecificationsForm);
      setFieldSetting(pendingSpecificationsForm, 'lContractTypeKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllContractTypeFetched, AllContractTypeData])

  useEffect(() => {
    if (isAllSalesrepsFetched && AllSalesrepsData) {
      setDropdownOptions(AllSalesrepsData, 'lSalesRepKey', 'repName', pendingSpecificationsForm, 'lSalesRepKey', setPendingSpecificationsForm);
      setFieldSetting(pendingSpecificationsForm, 'lSalesRepKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllSalesrepsFetched, AllSalesrepsData])

  useEffect(() => {
    if (pendingContractData) {
      const formData = { ...pendingSpecificationsForm };
      formData.initialState = {
        lContractTypeKey: pendingContractData.lContractTypeKey,
        lSalesRepKey: pendingContractData.lSalesRepKey,
        dtContractTermMonth: pendingContractData.lTermMonths,
        lPendingContractAgreementTemplateKey: pendingContractData.lPendingContractAgreementTemplateKey,
        status: pendingContractData.sStatus,
        sShipAddr1: pendingContractData.sPendingContractAddr1,
        sShipAddr2: pendingContractData.sPendingContractAddr2,
        sShipCity: pendingContractData.sPendingContractCity,
        sShipState: pendingContractData.sPendingContractState,
        sShipZip: pendingContractData.sPendingContractZip,
        sContractFaxNumber: pendingContractData.sPendingContractFaxNumber,
      };
      setPendingSpecificationsForm(formData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingContractData]);


  return (
    <>
      <div className="row">
        <FormCreator
          ref={SpecificationsRef}
          config={pendingSpecificationsForm}
        />
      </div>
    </>
  );
};

export default Specifications;
